import { api } from "@/config/api-fetch";
import { useQuery } from "@tanstack/react-query";

export type Conversation = {
    id: number;
    title: string;
    created_at: number;
    messages: {
        created_at: number;
        sender: "user" | "assistant";
        message: string;
    }[];
};

export function useConversations() {
    const query = useQuery({
        queryKey: ["conversations"],
        queryFn: async () => api.get<Conversation[]>("/conversations"),
    });

    return query;
}
